module.exports = __webpack_public_path__ + "img/sponsor-bbva-logo.fed28b75.jpg";